<div *ngIf="caseTitle == typeIrops.CANCELLED">
  {{ "srIrops.yourItineraryCancelledR" | translate: { cityName } }}
</div>
<div *ngIf="caseTitle == typeIrops.DELAYED">
  <span [innerHTML]="'srIrops.yourItineraryModifyR' | translate: { cityName } "></span>
</div>
<div *ngIf="caseTitle == typeIrops.EARLY">
  <span [innerHTML]="'srIrops.yourItineraryEarlyR' | translate: { cityName } "></span>
</div>
